<template>
  <div>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane :label="$t('m.mouth_anchor')" name="mouthAnchor">
        <mouthAnchorPageVue v-if="activeName === 'mouthAnchor'"></mouthAnchorPageVue>
      </el-tab-pane>
      <el-tab-pane :label="$t('m.day_anchor')" name="dayAnchor" v-if="userState">
        <dayAnchorPageVue v-if="activeName === 'dayAnchor'"></dayAnchorPageVue>
      </el-tab-pane>
      <el-tab-pane :label="$t('m.guild_anchor')" name="guildAnchor" v-if="userState">
        <guildAnchorPageVue v-if="activeName === 'guildAnchor'"></guildAnchorPageVue>
      </el-tab-pane>
      <el-tab-pane :label="$t('m.agent_nvitation_eward')" name="GuildInviteReward">
        <GuildInviteRewardPage v-if="activeName === 'GuildInviteReward'"></GuildInviteRewardPage>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { getDayAnchorState } from '../../api/revenues/anchor-revenues';
import dayAnchorPageVue from './dayAnchorPage.vue';
import guildAnchorPageVue from './guildAnchorPage.vue';
import GuildInviteRewardPage from './guildInviteRewardPage.vue';
import mouthAnchorPageVue from './mouthAnchorPage.vue';

export default {
  name: 'BcAnchorRevenuesPage',
  components: {
    mouthAnchorPageVue,
    dayAnchorPageVue,
    guildAnchorPageVue,
    GuildInviteRewardPage
  },
  data() {
    return {
      activeName: 'mouthAnchor',
      userState:false,
    };
  },

  mounted() {
    this.getDayAnchorStateFun();
  },

  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    getDayAnchorStateFun() {
      getDayAnchorState().then(({data}) => {
        if (data.data.showAward) {
          this.userState = true;
        }
      })
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/revenues/anchorRevenuesPage.vue